import React from "react";

const WA_NUMBER = "918849440828"; // +91 88494 40828

/**
 * Build a WhatsApp deep-link with a prefilled message.
 * Works on mobile (opens app) and desktop (opens web.whatsapp.com).
 */
export const waUrl = (message = "Hi! I'd like to know more about your pieces.") =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

/**
 * WhatsApp SVG mark — tinted copper → white on hover to match the brand.
 */
export const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.981.999-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.885-9.885 9.885M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.892c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652a12.062 12.062 0 005.71 1.447h.006c6.585 0 11.946-5.335 11.949-11.893 0-3.17-1.24-6.15-3.495-8.396"/>
  </svg>
);

/**
 * Floating WhatsApp FAB — bottom-right, visible on every site page.
 * Hidden on /admin routes (added by App.js conditional rendering).
 */
const WhatsAppFab = () => (
  <a
    href={waUrl("Hi Venus 3D Creations! I had a question about your lamps.")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with Venus 3D Creations on WhatsApp"
    data-testid="whatsapp-fab"
    className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#25D366] text-white px-4 h-14 rounded-full shadow-[0_14px_34px_-10px_rgba(37,211,102,0.55)] hover:shadow-[0_18px_40px_-10px_rgba(37,211,102,0.75)] transition-all hover:-translate-y-0.5 group"
  >
    <WhatsAppIcon className="w-6 h-6" />
    <span className="hidden sm:inline text-xs tracking-[0.18em] uppercase font-medium">Chat</span>
  </a>
);

export default WhatsAppFab;
